/* eslint-disable max-len */
import React from 'react';
import SplitPane from 'react-split-pane';
import useLocalStorage from 'react-use/lib/useLocalStorage';
import { Redirect } from 'wouter';
import { LFC } from '../../Legacy';
import { Icon } from '../../concepts/resources/Icon';
import { Fill } from '../../ui/Fill';
import { VerticalTabSet } from '../../ui/VerticalTabSet';
import { UseLocationScope } from '../AppLocation';
import { AccountHeaderBlock } from '../account/AccountHeaderBlock';
import { PlanStateHeaderBlock } from '../account/PlanStateHeaderBlock';
import { Crumbs } from '../common/Crumbs';
import { Page } from '../common/Page';
import { FlexFrame } from '../dashboard/elements/LayoutElements';
import { remInPx } from './../../ui';
import { ManageUserAccessControlView } from './ManageUserAccessControlView';

const XSplitPane = SplitPane as any;

const ManageSecurityLayout: LFC<{ param?: string }> = ({ param }) => {

    const [leftSize, setLeftSize] = useLocalStorage('deqo/ui/security/leftSize', remInPx(18));

    if (!param) {
        return <Redirect to={'/manage/security/access'} />;
    }

    return <Fill flex="column">
        <FlexFrame>
            <VerticalTabSet>
                <XSplitPane className="flex" split="vertical" minSize={remInPx(12)} size={leftSize} maxSize={remInPx(30)} onChange={setLeftSize}>
                    <VerticalTabSet.Menu expand>
                        <VerticalTabSet.Link to="~/manage/security/access" selected={param === 'access'}>
                            <Icon size="1.5" src="deqo://icons/hero/credit-card" />&nbsp;&nbsp;Access Control
                        </VerticalTabSet.Link>
                        <VerticalTabSet.Link to="~/manage/security/sso" selected={param === 'sso'}>
                            <Icon size="1.5" src="deqo://icons/hero/key" />&nbsp;&nbsp;Single Sign-On
                        </VerticalTabSet.Link>
                    </VerticalTabSet.Menu>
                    <VerticalTabSet.Content>
                        {param === 'access' && <ManageUserAccessControlView />}
                    </VerticalTabSet.Content>
                </XSplitPane>
            </VerticalTabSet>
        </FlexFrame>
    </Fill>;
};

export const ManageSecurityView: LFC<{ param?: string }> = ({ param }) => <>
    <UseLocationScope name="access" label={'Security & Login'} />
    <Page.Header>
        <Crumbs items={[
            ['Manage', '/manage'],
            ['Security & Login', null],
        ]} />
        <Page.HeaderPush>
            <PlanStateHeaderBlock />
            <AccountHeaderBlock />
        </Page.HeaderPush>
    </Page.Header>
    <Page.Content>
        <ManageSecurityLayout param={param} />
    </Page.Content>
</>
    ;
